import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, inject, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SHORT_LOCALE_ID } from '../../../shared/initialize.provider';

declare let window: Window & { windowRef: Window };

@Component({
  selector: 'core-eula',
  templateUrl: './eula.component.html',
  styleUrls: ['./eula.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EulaComponent {
  @ViewChild('printElement', { static: true }) printElement: ElementRef<HTMLDivElement>;
  template: SafeHtml;
  locale = inject(SHORT_LOCALE_ID);

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer
  ) {
    const url =
      this.locale === 'en' ? './assets/templates/eula.en.html' : './assets/templates/eula.fr.html';
    this.http.get(url, { responseType: 'text' }).subscribe(html => {
      this.template = this.sanitizer.bypassSecurityTrustHtml(html);
    });
  }

  print(): void {
    const printContent = this.printElement.nativeElement;
    const windowPopup = window.open('', '', 'top=0,left=0,height=100%,width=auto');
    windowPopup.document.write(printContent.innerHTML);
    windowPopup.document.close();

    // I need this in cypress to close it
    window.windowRef = windowPopup;

    windowPopup.setTimeout(() => {
      windowPopup.focus();
      windowPopup.print();
      windowPopup.close();
    }, 250);
  }
}
